import { render, staticRenderFns } from "./phase-history.vue?vue&type=template&id=61acd3ee&"
import script from "./phase-history.vue?vue&type=script&lang=ts&"
export * from "./phase-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports